<div class="dialog-bar flex">
    <div class="dialog-header flex">
        <ng-container>
            {{ headerValue }}
        </ng-container>
    </div>
</div>